module.exports = __webpack_public_path__ + "static/media/Gucci-Metallic-Princeton-Slide-Loafers-Lyst_thumb.18fae07d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/shoes/Gucci-Metallic-Princeton-Slide-Loafers-Lyst_thumb.png
// module id = 276
// module chunks = 0